import './mailCodeOffer.scss';

import { uniqueId } from 'lodash';
import { Trans, useTranslation } from 'react-i18next';

import { locator } from '../../../testing/e2e-locator/locator';
import { MailCodeOfferProps } from './types/MailCodeOfferProps';

export const MailCodeOffer = ({
  originalPaymentAmount,
  refinancePaymentAmount,
  savingsAmount,
}: MailCodeOfferProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div
      className="mail-code-offer-container"
      data-testid={locator.components.mailCodeOffer.root}
    >
      <div>
        <label
          data-testid={locator.components.mailCodeOffer.originalPaymentLabel}
        >
          <Trans
            components={[<u key={uniqueId('u-')} />]}
            i18nKey={'mailCodeOffer.estOriginalPayment'}
          />
        </label>
        <span data-testid={locator.components.mailCodeOffer.originalPayment}>
          {t('mailCodeOffer.estOriginalPaymentAmount', {
            amount: originalPaymentAmount,
          })}
        </span>
      </div>

      <div>
        <label
          data-testid={locator.components.mailCodeOffer.refinancePaymentLabel}
        >
          <Trans
            components={[<u key={uniqueId('u-')} />]}
            i18nKey={'mailCodeOffer.estRefinancePayment'}
          />
        </label>
        <span data-testid={locator.components.mailCodeOffer.refinancePayment}>
          {t('mailCodeOffer.estRefinancePaymentAmount', {
            amount: refinancePaymentAmount,
          })}
        </span>
      </div>

      <div>
        <label
          data-testid={locator.components.mailCodeOffer.savingsAmountLabel}
        >
          <Trans
            components={[<u key={uniqueId('u-')} />]}
            i18nKey={'mailCodeOffer.estSavings'}
          />
        </label>
        <span data-testid={locator.components.mailCodeOffer.savingsAmount}>
          {t('mailCodeOffer.estSavingsAmount', { amount: savingsAmount })}
        </span>
      </div>
    </div>
  );
};
